/** API route map: URLS.Controller.QuickBook */
export const QuickBook = {
      Name: 'QuickBook/',
      Enable: 'enable',
      Connect: 'connect',
      GetConfiguration: 'get-config',
      Disconnect: 'disconnect',
      GetCompanyInfo: 'get-company-info',
};
